(function () {
  var STORAGE_KEY = "web-glassworks-v1";

  function boot() {
    var root = document.querySelector('.puzzle-page[data-puzzle="glassworks"]');
    if (!root || root.getAttribute("data-booted") === "1") return;
    root.setAttribute("data-booted", "1");
    startPuzzle(root);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  function startPuzzle(root) {
    function q(id) { return root.querySelector("#" + id); }

    var nodes = {
      dek: q("dek"),
      seed: q("case-seed"),
      letter: q("letter"),
      clues: q("clue-list"),
      standing: q("standing"),
      struck: q("struck-count"),
      check: q("check"),
      reveal: q("reveal"),
      status: q("status"),
      section: q("section-label"),
      page: q("page-label"),
      columns: q("columns"),
      prev: q("prev-page"),
      next: q("next-page"),
      jumps: q("page-jumps"),
      newCase: q("new-case"),
      modal: q("modal"),
      modalYes: q("modal-yes"),
      modalNo: q("modal-no"),
      spoil: q("spoil"),
      spoilYes: q("spoil-yes"),
      spoilNo: q("spoil-no"),
    };

    var state = null;

    function engine() { return globalThis.CaseEngine; }

    function randomSeed() {
      var buf = new Uint32Array(1);
      crypto.getRandomValues(buf);
      return buf[0];
    }

    function blankPlay(puzzle) {
      return {
        version: puzzle.version,
        seed: puzzle.seed,
        people: puzzle.people,
        killerId: puzzle.killerId,
        clues: puzzle.clues,
        struck: [],
        checked: puzzle.clues.map(function () { return false; }),
        folderPage: 1,
        revealed: false,
        checkedOnce: false,
      };
    }

    function save() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    }

    function load() {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      engine().assertCase(parsed);
      var total = engine().LAYOUT.total;
      var struck = Array.isArray(parsed.struck)
        ? parsed.struck.filter(function (id, index, list) {
          return Number.isInteger(id) && id >= 0 && id < total && list.indexOf(id) === index;
        })
        : [];
      var folderPage = Number(parsed.folderPage) || 1;
      if (folderPage < 1 || folderPage > engine().LAYOUT.pages) folderPage = 1;
      return {
        version: parsed.version,
        seed: parsed.seed,
        people: parsed.people,
        killerId: parsed.killerId,
        clues: parsed.clues,
        struck: struck,
        checked: parsed.clues.map(function (_, i) { return Boolean(parsed.checked && parsed.checked[i]); }),
        folderPage: folderPage,
        revealed: Boolean(parsed.revealed),
        checkedOnce: Boolean(parsed.checkedOnce),
      };
    }

    function deal(seed) {
      state = blankPlay(engine().createCase(seed));
      save();
      renderAll();
    }

    function fullName(id) {
      return state.people[id][0] + " " + state.people[id][1];
    }

    function standingCount() {
      return engine().LAYOUT.total - state.struck.length;
    }

    function renderLetter() {
      nodes.letter.replaceChildren();
      engine().introParagraphs().forEach(function (para) {
        var p = document.createElement("p");
        p.textContent = para;
        nodes.letter.append(p);
      });
    }

    function renderClues() {
      nodes.clues.replaceChildren();
      state.clues.forEach(function (clue, index) {
        var li = document.createElement("li");
        var label = document.createElement("label");
        label.className = "clue";
        var input = document.createElement("input");
        input.type = "checkbox";
        input.checked = Boolean(state.checked[index]);
        input.disabled = state.revealed;
        input.addEventListener("change", function () {
          if (state.revealed) return;
          state.checked[index] = input.checked;
          save();
        });
        var span = document.createElement("span");
        span.textContent = clue.text;
        label.append(input, span);
        li.append(label);
        nodes.clues.append(li);
      });
    }

    function renderSheet() {
      var layout = engine().LAYOUT;
      var pos = engine().position((state.folderPage - 1) * layout.perPage);
      nodes.section.textContent = engine().SECTIONS[pos.chapter];
      nodes.page.textContent = "Folder page " + state.folderPage + " of " + layout.pages;
      nodes.prev.disabled = state.folderPage <= 1;
      nodes.next.disabled = state.folderPage >= layout.pages;
      nodes.jumps.replaceChildren();
      for (var page = 1; page <= layout.pages; page++) {
        var button = document.createElement("button");
        button.type = "button";
        button.dataset.page = String(page);
        button.textContent = String(page);
        if (page === state.folderPage) button.setAttribute("aria-current", "page");
        button.setAttribute("aria-label", "Folder page " + page);
        nodes.jumps.append(button);
      }
      var struck = {};
      state.struck.forEach(function (id) { struck[id] = true; });
      nodes.columns.replaceChildren();
      var base = (state.folderPage - 1) * layout.perPage;
      for (var col = 0; col < layout.cols; col++) {
        var column = document.createElement("div");
        column.className = "column";
        var heading = document.createElement("div");
        heading.className = "col-label";
        heading.textContent = "ABCD"[col];
        column.append(heading);
        for (var row = 0; row < layout.rows; row++) {
          if (row === layout.halfRows) {
            var rule = document.createElement("div");
            rule.className = "half-rule";
            column.append(rule);
          }
          var id = base + col * layout.rows + row;
          var nameButton = document.createElement("button");
          nameButton.type = "button";
          nameButton.className = "name";
          nameButton.dataset.id = String(id);
          var name = fullName(id);
          nameButton.textContent = name;
          nameButton.title = name;
          var isStruck = Boolean(struck[id]);
          var isFound = state.revealed && id === state.killerId;
          if (isStruck && !isFound) nameButton.classList.add("struck");
          if (isFound) nameButton.classList.add("found");
          nameButton.disabled = state.revealed;
          nameButton.setAttribute("aria-pressed", isStruck ? "true" : "false");
          column.append(nameButton);
        }
        nodes.columns.append(column);
      }
    }

    function renderStatusChrome() {
      nodes.seed.textContent = "Case " + engine().caseLabel(state.seed);
      nodes.standing.textContent = standingCount() + " standing";
      nodes.struck.textContent = state.struck.length + " crossed out";
      nodes.check.classList.toggle("ready", standingCount() === 1);
      nodes.check.disabled = state.revealed;
      nodes.reveal.hidden = state.revealed;
    }

    function renderAll() {
      nodes.dek.textContent = engine().DEK;
      renderLetter();
      renderClues();
      renderSheet();
      renderStatusChrome();
      if (!state.revealed && !state.checkedOnce) nodes.status.textContent = "";
    }

    function setStatus(text, kind) {
      nodes.status.textContent = text;
      nodes.status.className = kind || "";
    }

    function placePhrase(id) {
      var pos = engine().position(id);
      var section = engine().SECTIONS[pos.chapter];
      var column = "ABCD"[pos.col];
      return fullName(id) + ": section " + section + ", folder page " + pos.page + ", column " + column + ".";
    }

    function openModal() {
      nodes.modal.hidden = false;
      nodes.modalNo.focus();
    }

    function closeModal() {
      nodes.modal.hidden = true;
      nodes.newCase.focus();
    }

    function openSpoil() {
      nodes.spoil.hidden = false;
      nodes.spoilNo.focus();
    }

    function closeSpoil() {
      nodes.spoil.hidden = true;
      nodes.reveal.focus();
    }

    function hasMarks() {
      return state.struck.length > 0 || state.checked.some(Boolean) || state.revealed || state.checkedOnce;
    }

    function showGuilty() {
      state.revealed = true;
      state.folderPage = engine().position(state.killerId).page;
      setStatus(placePhrase(state.killerId), "ok");
      save();
      renderClues();
      renderSheet();
      renderStatusChrome();
      var found = nodes.columns.querySelector(".found");
      if (found) found.scrollIntoView({ block: "center" });
    }

    nodes.newCase.addEventListener("click", function () {
      if (hasMarks()) openModal();
      else deal(randomSeed());
    });

    nodes.modalYes.addEventListener("click", function () {
      closeModal();
      setStatus("Drawing a new folder…", "");
      window.setTimeout(function () { deal(randomSeed()); }, 30);
    });

    nodes.modalNo.addEventListener("click", closeModal);
    nodes.modal.addEventListener("click", function (event) {
      if (event.target === nodes.modal) closeModal();
    });

    nodes.reveal.addEventListener("click", openSpoil);
    nodes.spoilYes.addEventListener("click", function () {
      closeSpoil();
      showGuilty();
    });
    nodes.spoilNo.addEventListener("click", closeSpoil);
    nodes.spoil.addEventListener("click", function (event) {
      if (event.target === nodes.spoil) closeSpoil();
    });

    root.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (!nodes.spoil.hidden) closeSpoil();
      else if (!nodes.modal.hidden) closeModal();
    });

    nodes.prev.addEventListener("click", function () {
      if (state.folderPage <= 1) return;
      state.folderPage -= 1;
      save();
      renderSheet();
    });

    nodes.next.addEventListener("click", function () {
      if (state.folderPage >= engine().LAYOUT.pages) return;
      state.folderPage += 1;
      save();
      renderSheet();
    });

    nodes.jumps.addEventListener("click", function (event) {
      var button = event.target.closest("[data-page]");
      if (!button) return;
      state.folderPage = Number(button.dataset.page);
      save();
      renderSheet();
    });

    nodes.columns.addEventListener("click", function (event) {
      var button = event.target.closest(".name");
      if (!button || state.revealed) return;
      var id = Number(button.dataset.id);
      var index = state.struck.indexOf(id);
      if (index >= 0) state.struck.splice(index, 1);
      else state.struck.push(id);
      save();
      renderSheet();
      renderStatusChrome();
    });

    nodes.check.addEventListener("click", function () {
      if (state.revealed) return;
      var struck = {};
      state.struck.forEach(function (id) { struck[id] = true; });
      var standing = [];
      for (var id = 0; id < state.people.length; id++) if (!struck[id]) standing.push(id);
      state.checkedOnce = true;
      if (standing.length === 0) setStatus("Every name is crossed out. Restore the name you want to test.", "bad");
      else if (standing.length > 1) setStatus(standing.length + " names are still standing. The note fits only one.", "");
      else if (standing[0] === state.killerId) {
        state.revealed = true;
        state.folderPage = engine().position(state.killerId).page;
        setStatus("Yes. " + placePhrase(standing[0]) + " That name fits every line of the note.", "ok");
        renderClues();
        renderSheet();
      } else setStatus("No. " + fullName(standing[0]) + " does not fit the note.", "bad");
      save();
      renderStatusChrome();
    });

    nodes.dek.textContent = engine().DEK;
    try { state = load(); } catch (err) { state = null; }
    if (state) {
      renderAll();
      if (state.revealed) setStatus(placePhrase(state.killerId), "ok");
      return;
    }
    setStatus("Drawing the folder…", "");
    window.setTimeout(function () {
      try {
        deal(randomSeed());
        setStatus("", "");
      } catch (err) {
        setStatus("The folder could not be drawn. Reload the page to try again.", "bad");
      }
    }, 30);
  }
})();
